export const domainsConstants = {
  DOMAINS_REQUEST: 'GET_DOMAINS_REQUEST',
  DOMAINS_SUCCESS: 'GET_DOMAINS_SUCCESS',
  DOMAINS_FAILURE: 'GET_DOMAINS_FAILURE',

  BUL_IMAGINE_KAIZEN: 'HANDLE_BUL_IMAGINE_KAIZEN',
  SET_LOCALS_IMAGINE: 'SET_LOCALS_IMAGINE',
};
